import { render, staticRenderFns } from "./RefundTypeForm.vue?vue&type=template&id=56e5e5de&"
import script from "./RefundTypeForm.vue?vue&type=script&lang=js&"
export * from "./RefundTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports